<template>
    <div>
        <h4 class="subtitle is-6 mb-2">
            Our latest recorded utility meter readings.
        </h4>

        <div
            v-if="tenancy"
            class="columns is-multiline"
        >
            <Utility
                type="Water"
                icon="tint"
                :start-reading="tenancy.strWaterStart"
                :end-reading="tenancy.strWaterEnd"
            />

            <Utility
                type="Gas"
                icon="burn"
                :start-reading="tenancy.strGasStart"
                :end-reading="tenancy.strGasEnd"
            />

            <Utility
                type="Electricity Peak"
                icon="lightbulb"
                icon-pack="far"
                :start-reading="tenancy.strElectricityPeakStart"
                :end-reading="tenancy.strElectricityPeakEnd"
            />

            <Utility
                type="Electricity Off Peak"
                icon="lightbulb"
                :start-reading="tenancy.strElectricityOffPeakStart"
                :end-reading="tenancy.strElectricityOffPeakEnd"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Utility from '../components/Utility.vue';

export default {
    components: {
        Utility,
    },

    computed: {
        ...mapState('tenancyProperty', [
            'tenancy',
        ]),
    },
};
</script>
